import { CommonStudent } from '@codidae/common-types';
import Altus from 'components/altus/altus';
import Button from 'components/button/button';
import Flex from 'components/flex/flex';
import { useMemo } from 'react';
import Confetti from 'react-confetti';
import { BiChevronRight, BiVideo } from 'react-icons/bi';
import { FaChild } from 'react-icons/fa';
import { IoCheckmarkCircle } from 'react-icons/io5';
import styles from './child-dashboard.module.scss';

export default function ConfigHelper({ child, onFinish }: { child?: CommonStudent; onFinish: VoidFunction }) {
  const step = useMemo(() => {
    if (!child) return 0;
    if (!child.firstLogin) return 1;
    if (!child.configuredBlocker) return 2;
    return 3;
  }, [child]);

  return (
    <Flex
      direction="column"
      height="100%"
      width="100%"
      align="center"
      pad={20}
      gap={30}
      style={{ overflowY: 'scroll' }}
      className={styles.configHelper}
    >
      {step === 3 && <Confetti style={{ position: 'fixed', top: 0, left: 0 }} />}

      <Flex className={styles.text} align="center" gap={20} width="100%">
        <IoCheckmarkCircle className={styles.checkmark} />
        Créer le compte parent
      </Flex>
      <div className={styles.separator}>
        {step === 1 && <Altus width={100} className={styles.altus} type="green_phone" />}
      </div>
      <Flex width="100%" direction="column" gap={20}>
        <Flex className={styles.text} align="center" gap={20} width="100%">
          {step <= 1 ? <div className={styles.stepNumber}>2</div> : <IoCheckmarkCircle className={styles.checkmark} />}
          <div>
            <div>Connecter {child?.firstname ?? 'votre enfant'} sur son profil</div>
            {step === 1 && (
              <div className={styles.description}>
                Télécharger Altus sur le téléphone de {child?.firstname ?? 'votre enfant'} et connectez votre enfant par{' '}
                <b>code d&apos;appairage</b> ou <b>QRCode.</b>
              </div>
            )}
          </div>
        </Flex>
        {step === 1 && (
          <Button href={`/auth/pair/${child?.id}`} icon={<FaChild />}>
            CONNECTER MON ENFANT
          </Button>
        )}
      </Flex>
      <div className={styles.separator}>
        {step === 2 && <Altus width={80} className={styles.altus} type="look_at_key" />}
      </div>
      <Flex width="100%" direction="column" gap={20}>
        <Flex className={styles.text} align="center" gap={20} width="100%">
          {step <= 2 ? <div className={styles.stepNumber}>3</div> : <IoCheckmarkCircle className={styles.checkmark} />}
          <div>
            <div>Configurer le bloqueur Altus</div>
            {step === 2 && (
              <div className={styles.description}>
                Suivez les instructions sur le téléphone de {child?.firstname ?? 'votre enfant'}, ou regardez ce
                tutoriel
              </div>
            )}
          </div>
        </Flex>
        {step === 2 && (
          <Button
            onClick={() => {
              window.open('https://www.youtube.com/watch?v=W_B7qJ7ZVho', '_blank');
            }}
            icon={<BiVideo />}
          >
            REGARDER LE TUTORIEL
          </Button>
        )}
      </Flex>
      <div className={styles.separator} />
      {step === 3 && (
        <Flex width="100%" align="center" justify="space-between" height="100%" direction="column">
          <Button onClick={() => onFinish()} icon={<BiChevronRight />}>{`ACCÉDER À L'ESPACE PARENT`}</Button>
          <div style={{ height: 20 }} />
          <Flex direction="column" align="center" gap={20}>
            <Altus type="confeti" width={100} />
            <div className={styles.tadaText}>Configuration terminée !</div>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
}
